export const getAuth0RedirectOrigin = (locationObject = window.location) => {
  const origin = locationObject?.origin || '';

  try {
    const url = new URL(origin);
    if (url.protocol === 'https:' && url.hostname === 'www.botspot.trade') {
      return 'https://botspot.trade';
    }
  } catch {
    return origin;
  }

  return origin;
};
